import * as zod from "zod";

export const getUpsGhostAccounts = {
  name: "getUpsGhostAccounts" as const,
  input: zod.object({ teamId: zod.string() }),
  output: zod.object({ locations: zod.array(zod.string()) }),
};
